import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {
  APP_LANGS,
  DEFAULT_LANG,
  LOCAL_LANG_KEY,
  allAppLangKeys,
  normalizeLangKey,
  resolveStartupLang,
  type AppLang,
} from "@/lib/env";

type LanguageItem = {
  key: AppLang;
  shortName: string;
  fullName: string;
  value: number;
  label: string;
  orderCode: string | null;
  /** Tashqi app lar ishlatadigan alias keylar */
  aliases: string[];
};

export const LanguageList: LanguageItem[] = [
  {
    key: "uz_latn",
    shortName: "O`z",
    fullName: "O`zbekcha",
    value: 3,
    label: "O`zbekcha",
    orderCode: null,
    aliases: allAppLangKeys.uz_latn,
  },
  {
    key: "ru",
    shortName: "Ру",
    fullName: "Русский",
    value: 1,
    label: "Русский",
    orderCode: null,
    aliases: allAppLangKeys.ru,
  },
  {
    key: "en",
    shortName: "En",
    fullName: "English",
    value: 5,
    label: "English",
    orderCode: null,
    aliases: allAppLangKeys.en,
  },

  // {
  //   key: "uz_cyrl",
  //   shortName: "Ўз",
  //   fullName: "Ўзбекча",
  //   value: 2,
  //   label: "Ўзбекча",
  //   orderCode: null,
  // },

];
export const SUPPORT_LOCALES = APP_LANGS;
const fallbackLng = DEFAULT_LANG;
const defaultLocale = resolveStartupLang();
localStorage.setItem(LOCAL_LANG_KEY, normalizeLangKey(defaultLocale) ?? fallbackLng);

// Asosiy sozlama (bo‘sh resources bilan)
i18n.use(initReactI18next).init({
  fallbackLng,
  lng: defaultLocale,
  debug: false,
  interpolation: { escapeValue: false },
  resources: {}, // empty, chunki biz keyincha dynamic yuklaymiz
  react: {
    useSuspense: false,
    // bindI18n: "languageChanged loaded",
    // bindI18nStore: "added removed",
  },
});

/**
 * Dynamic locale message loader
 */
export const loadLocaleMessages = async (locale: string) => {
  if (!i18n.hasResourceBundle(locale, "translation")) {
    const messages = await import(`./localizer/${locale}.json`);
    i18n.addResourceBundle(
      locale,
      "translation",
      messages.default || messages,
      true,
      true
    );
  }
  await i18n.changeLanguage(locale); // muhim!
};

export default i18n;
